export default function PageJsonLd() {
  const baseUrl = 'https://business-training.by';
  const pageUrl = `${baseUrl}/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya`;

  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: { '@id': baseUrl, name: 'Главная' } },
      { '@type': 'ListItem', position: 2, name: 'Энциклопедия корпоративного обучения', item: { '@id': `${baseUrl}/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie`, name: 'Энциклопедия корпоративного обучения' } },
      { '@type': 'ListItem', position: 3, name: 'Корпоративная академия', item: { '@id': pageUrl, name: 'Корпоративная академия' } },
    ],
  };

  const organization = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'BusinessTraining.by',
    url: baseUrl,
    description:
      'Корпоративное обучение и развитие персонала. Создание корпоративных академий, тренинги для руководителей, обучение отделов продаж, развитие Soft Skills и командообразование.',
    founder: {
      '@type': 'Person',
      name: 'Алексей Сивко',
    },
  };

  const service = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Создание корпоративной академии',
    description:
      'Разработка и внедрение корпоративной системы обучения сотрудников. Включает диагностику компетенций, создание матрицы компетенций, карты обучения, программ, наставничества, базы знаний и системы оценки.',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      jobTitle: 'Бизнес-тренер, практикующий консультант',
      url: baseUrl,
    },
    areaServed: { '@type': 'Place', name: 'Беларусь, Россия, Казахстан, Израиль' },
    serviceType: 'Корпоративное обучение и развитие персонала',
    offers: {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Корпоративная академия под ключ',
      },
    },
    url: pageUrl,
  };

  const person = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Алексей Сивко',
    jobTitle: 'Бизнес-тренер, практикующий консультант',
    description:
      'Практикующий бизнес-тренер с 18+ лет опыта. 100+ корпоративных проектов, 450+ тренингов, 4500+ участников. Компании Беларуси, России, Казахстана и Израиля. Автор системного подхода к развитию продаж и обучению сотрудников.',
    url: baseUrl,
    sameAs: [
      'https://www.linkedin.com/in/sivko-trainer',
      'https://www.instagram.com/sivko_trainer',
    ],
    knowsAbout: [
      'Корпоративная академия',
      'Система обучения сотрудников',
      'Корпоративное обучение',
      'L&D',
      'Learning and Development',
      'Развитие персонала',
      'Матрица компетенций',
      'Управление знаниями',
    ],
  };

  const faqQuestions = [
    {
      '@type': 'Question',
      name: 'Что такое корпоративная академия?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Корпоративная академия — это система развития сотрудников внутри компании, которая включает диагностику компетенций, программы обучения, наставничество, базу знаний и оценку эффективности. В отличие от разовых тренингов, академия создаёт непрерывный цикл обучения, который работает без постоянного участия руководителя.',
      },
    },
    {
      '@type': 'Question',
      name: 'Зачем нужна корпоративная академия?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Корпоративная академия решает ключевые бизнес-задачи: ускоряет адаптацию новичков, снижает текучесть, стандартизирует работу, накапливает внутренние знания, развивает руководителей и масштабирует бизнес без потери качества.',
      },
    },
    {
      '@type': 'Question',
      name: 'Чем корпоративная академия отличается от учебного центра?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Учебный центр — это место или платформа для проведения обучения. Корпоративная академия — это система: методология, компетенции, программы, наставники, база знаний, оценка. Учебный центр — часть академии, но не наоборот.',
      },
    },
    {
      '@type': 'Question',
      name: 'Когда компании нужна корпоративная академия?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Когда компания быстро растёт, высокая текучесть, много новичков, несколько филиалов, нет единых стандартов, сильная зависимость от отдельных сотрудников, сложный продукт или планируется масштабирование бизнеса.',
      },
    },
    {
      '@type': 'Question',
      name: 'Можно ли создать академию без LMS?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да, на первых этапах LMS не обязательна. Главное — методология, стандарты, программы, наставники и система оценки. LMS — удобный инструмент, но не замена системе. Многие компании успешно запускают академию с Google Drive, чек-листами и очными сессиями.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как обучать сотрудников внутри компании?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Через систему корпоративного обучения: определить необходимые компетенции, создать программы по ролям, подготовить внутренних тренеров и наставников, внедрить практику и оценку, создать базу знаний и обеспечить регулярное повторение.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как организовать систему обучения персонала?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Поэтапно: 1) диагностика компетенций, 2) описание матрицы компетенций, 3) проектирование системы обучения, 4) создание программ, 5) подготовка внутренних тренеров, 6) запуск, 7) сопровождение и развитие академии.',
      },
    },
    {
      '@type': 'Question',
      name: 'Что входит в корпоративную академию?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Онбординг новых сотрудников, академия продаж, школа руководителей, развитие Soft Skills, база знаний, наставничество, внутренние тренеры, электронное обучение, бизнес-игры, оценка компетенций, карьерные треки, индивидуальные планы развития.',
      },
    },
    {
      '@type': 'Question',
      name: 'Кто отвечает за корпоративное обучение?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'L&D-специалист или HR Business Partner координирует систему обучения. Но ответственность за результат лежит на руководителях подразделений, которые должны поддерживать обучение и требовать применения новых навыков.',
      },
    },
    {
      '@type': 'Question',
      name: 'Сколько стоит создание корпоративной академии?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Стоимость зависит от размера компании, количества программ, глубины проработки и формата внедрения. Это инвестиция, которая окупается через снижение текучести, ускорение адаптации и рост эффективности. Точный расчёт — после диагностики.',
      },
    },
    {
      '@type': 'Question',
      name: 'Можно ли внедрить академию поэтапно?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да, поэтапное внедрение — лучшая практика. Обычно начинают с онбординга и обучения отдела продаж, затем добавляют школу руководителей, потом Soft Skills и базу знаний. Каждый этап приносит измеримые результаты.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как измерять эффективность корпоративной академии?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'По ключевым метрикам: время адаптации новичков, текучесть персонала, выполнение KPI, вовлечённость (eNPS), скорость карьерного роста, оценка компетенций до и после обучения, бизнес-показатели подразделений.',
      },
    },
    {
      '@type': 'Question',
      name: 'Чем отличается корпоративная академия от корпоративного университета?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Корпоративный университет — более масштабная структура, часто с собственным кампусом и академическими программами (как в СберУниверситете). Корпоративная академия — практическая система обучения, ориентированная на бизнес-результат здесь и сейчас. Для большинства компаний академия — оптимальный формат.',
      },
    },
    {
      '@type': 'Question',
      name: 'Как обучать руководителей внутри компании?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Через школу руководителей: управленческие компетенции, лидерство, делегирование, обратная связь, управление конфликтами. Формат: тренинги, бизнес-игры, разбор реальных кейсов, коучинговые сессии и регулярная оценка прогресса.',
      },
    },
    {
      '@type': 'Question',
      name: 'Подходит ли корпоративная академия для малого бизнеса?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Да, но в адаптированном формате. Для компании от 20 сотрудников можно создать облегчённую академию: онбординг, база знаний, наставничество и регулярное обучение. Это помогает стандартизировать работу и снизить зависимость от ключевых сотрудников.',
      },
    },
  ];

  const faqPage = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqQuestions,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      <script type="application/ld+json">{JSON.stringify(organization)}</script>
      <script type="application/ld+json">{JSON.stringify(service)}</script>
      <script type="application/ld+json">{JSON.stringify(person)}</script>
      <script type="application/ld+json">{JSON.stringify(faqPage)}</script>
    </>
  );
}